import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { KeycloakService } from '../../../../usermgmt/src/lib/services/keycloak.service';
import { TokenService, AppStateService } from 'usermgmt';


@Injectable({
    providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
    error!: string;
    statusCodes: any;
    errorMsgConfig: any = {};

    constructor(
        private tokenservice : TokenService,
        private keyCloakSrv : KeycloakService,
        private appStateSrv: AppStateService,
        private router: Router
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
            const customerUuid = this.appStateSrv.getCurrentCustomerId();
            let modifiedRequest = request;
            if (customerUuid) {
                modifiedRequest = request.clone({ headers: request.headers.set('customer-uuid', customerUuid) });
            }

            return next.handle(modifiedRequest).pipe(tap({
            next: () => {
                // do anything with the response if necessary
            },
            error: async (error) => {
                if (error instanceof HttpErrorResponse) {

                    //  this.errorMsgConfig = await this.cmnSrv.loadConfig({
                    //     path: Path.ERROR_MESSAGE_CONFIG_PATH,
                    //     configType: Config.ERROR_MESSAGE_CONFIG
                    // })
                    
                    if (error.status === 401) {
                        this.tokenservice.showtoaster()
                        setTimeout(() => {
                            this.router.navigate(['/landing']);
                        }, 1000);
                        return
                    } else {
                        const errorMessage = this.setError(error);
                        return throwError(() => errorMessage);
                    }
                } else {
                    return 
                }
            }
        }));
    }

    setError(err: HttpErrorResponse): string | Observable<any> {
        let errorMessage!: string;

        if (err.error instanceof ErrorEvent) {
            //client side error
            errorMessage = err.message
        } else {
            //server side error
            // const loggedIn = this.authSrv.isLoggedIn();
            // errorMessage = err.error.message ? err.error.message : this.errorMsgConfig?.[err?.status]?.message;

            if (err.status === 401) {
                this.tokenservice.showtoaster()
                return errorMessage;
            }

            // if (err.status === 400 && loggedIn) {
            //     errorMessage = err.error.message ? { message: err.error.message, code: err.error.statusCode }: this.errorMsgConfig[err?.status]?.message;
            // }

        }
        return errorMessage;
    }
}
